var map = {
	"./appointments.vue": "./resources/js/pages/widgets/appointments.vue",
	"./logins.vue": "./resources/js/pages/widgets/logins.vue",
	"./upcoming.vue": "./resources/js/pages/widgets/upcoming.vue",
	"./werkzaamheden.vue": "./resources/js/pages/widgets/werkzaamheden.vue"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "./resources/js/pages/widgets sync \\w+\\.(vue%7Cjs)$";